/*
    Label Module
*/
import cloneDeep from 'lodash/cloneDeep';
import labelConfigBuilder from './label-config-builder';
import { labelTooltip } from '../widget-utilities/widget-tooltip';
import d3Utils from '../../../utils/d3Utils';
import chartUtils from '../../../utils/chart-utils';

var label = function label() {
	// Render label widget
	var renderWidget = function renderWidget(widgetConfig) {
		var ContainerId = widgetConfig.ContainerId,
		    Height = widgetConfig.Height,
		    ModelName = widgetConfig.ModelName,
		    CloudName = widgetConfig.CloudName,
		    LabelConfig = widgetConfig.LabelConfig,
		    Data = widgetConfig.Data;


		var el = window.document.querySelector('#' + ContainerId);

		var height = Number(chartUtils.replaceAll(Height, '\x01', ''));

		var modelName = ModelName;
		var cloudName = CloudName;
		var crumbFormat = {
			CloudName: cloudName,
			ModelName: modelName,
			Type: 'Node',
			Name: '',
			FieldName: '',
			Value: ''
		};

		var displayText = "";

		var labelConfig = JSON.parse(chartUtils.replaceAll(JSON.stringify(LabelConfig), '\x01', ''));

		var seriesData = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.seriesData), '\x01', ''));

		var labelContainer = window.document.createElement('div');
		labelContainer.setAttribute('class', 'label-container');
		labelContainer.setAttribute('style', 'height:' + height + 'px;');
		el.appendChild(labelContainer);

		var labelGrid = window.document.createElement('div');
		labelGrid.setAttribute('class', 'label-grid');
		labelGrid.setAttribute('style', 'height:' + height + 'px;');
		labelContainer.appendChild(labelGrid);

		var seriesConfig = labelConfig.LabelSeries;

		for (var seriesIndex = 0; seriesIndex < seriesConfig.length; seriesIndex++) {
			var series = seriesConfig[seriesIndex];
			var tempSeriesData = seriesData[series.SeriesName];

			var mainLabelComponent = document.createElement('span');
			mainLabelComponent.setAttribute('class', 'label-component');
			if (series.FormatOptions != null) applyStyles(series.FormatOptions, mainLabelComponent);
			labelGrid.appendChild(mainLabelComponent);

			var mainLabelBox = document.createElement('div');
			mainLabelBox.setAttribute('class', 'mainlabel-box');

			var mainCategoryLabel = window.document.createElement('span');
			mainCategoryLabel.setAttribute('class', 'main-category-label');
			mainCategoryLabel.innerHTML = series.SeriesName;

			var mainValueLabel = window.document.createElement('span');
			mainValueLabel.setAttribute('class', LabelConfig.EmphasizeValue ? 'main-value-label emphasis' : 'main-value-label');

			if (series.Description != null && series.Description.toString() != '') {
				var mainDecriptionLabel = window.document.createElement('span');
				mainDecriptionLabel.innerHTML = '&nbsp;' + series.Description;
				mainValueLabel.appendChild(mainDecriptionLabel);
			}

			mainLabelBox.appendChild(mainCategoryLabel);
			mainLabelBox.appendChild(mainValueLabel);

			mainLabelComponent.appendChild(mainLabelBox);

			if (tempSeriesData == null) {
				mainValueLabel.innerHTML = 'No Data';
				continue;
			}

			var data = JSON.parse(tempSeriesData);
			var isCategorized = false;
			var mainValue = data[0][series.ValueField];
			var valueFormat = getValueFormat(series);
			var currencySymbol = getCurrencySymbol(series);
			var baseFormat = getBaseFormat(series);

			if (series.LabelField != null) {
				isCategorized = true;
				var totalValueName = 'Total-' + series.SeriesName;
				mainValue = data[0][totalValueName];
			}

			if (!mainValue) {
				mainValueLabel.innerHTML = 'No Data';
				continue;
			} else mainValueLabel.innerHTML = chartUtils.format(mainValue, valueFormat, currencySymbol, null, baseFormat);

			if (isCategorized) {
				var expandCategories = window.document.createElement('span');
				expandCategories.setAttribute('class', 'expand-categories');

				var expandCategoriesIcon = window.document.createElement('i');
				expandCategoriesIcon.setAttribute('class', 'fa fa-angle-right fa-3x');
				expandCategories.appendChild(expandCategoriesIcon);

				mainLabelBox.setAttribute('class', 'mainlabel-box categorized');

				mainLabelBox.appendChild(expandCategories);
			}

			if (isCategorized) addLabelCategories(series, data, mainLabelComponent);else {
				var d = data[0];
				var f = seriesConfig[seriesIndex];
				var tooltip = f.Tooltip;

				if (tooltip != null && tooltip.TooltipConfigs.length > 0) {
					var tooltipConfigs = tooltip.TooltipConfigs;
					for (var tipIndex = 0; tipIndex < tooltipConfigs.length; tipIndex++) {
						var tipItem = tooltipConfigs[tipIndex];

						var tipvalue = chartUtils.getTooltipValue(tipItem, d);

						if (tipItem.TipField == f.SeriesName && tipItem.AggregationType == "") tipValue = d[f.SeriesName];

						d[tipItem.Id] = tipvalue;
					}
				}
				var tooltipText = '';
				var tooltip = f.Tooltip;

				if (tooltip != null && tooltip.TooltipConfigs.length > 0 && displayText != null) {
					tooltipText = tooltip.TooltipText;

					for (var tipIndex = 0; tipIndex < tooltip.TooltipConfigs.length; tipIndex++) {
						var tipItem = tooltip.TooltipConfigs[tipIndex];

						var tipValue = d[tipItem.Id];

						if (tipValue == null || tipValue == "--") {

							var field = seriesConfig.find(function (element) {
								return element.labelField == tipItem.TipField;
							});

							if (field != null) tipValue = d[field.labelField];
						}

						if (tipValue != null && tipValue.toString().trim().length > 0) tipValue = chartUtils.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false);

						if (tipValue == null || tipValue.trim().length == 0) tipValue = "--";

						tooltipText = tooltipText.replace("{" + tipItem.TipField + "}", tipValue + " ");
					}
				}

				mainLabelBox.addEventListener("touchstart", function (e) {
					labelTooltip.onMouseOver.call(this, e);
				});
				mainLabelBox.addEventListener("mouseover", function (e) {
					labelTooltip.onMouseOver.call(this, e);
				});
				mainLabelBox.addEventListener("mouseout", function () {
					labelTooltip.onMouseOut();
				});
				mainLabelBox.addEventListener("touchmove", function () {
					labelTooltip.onTouchMove();
				});
				mainLabelBox.addEventListener("mousemove", function (e) {
					labelTooltip.onMouseMove.call(this, e);
				});

				mainLabelBox.setAttribute("label", tooltipText);

				mainLabelComponent.appendChild(mainLabelBox);

				if (series.FormatConfig != null) applyConditionalFormatting(series, displayText, mainLabelComponent, mainValue, data[0]);
				if (series.CrumbFieldName != null) {
					var crumb = crumbFormat;
					crumb.Name = series.CrumbMetaName;
					crumb.FieldName = series.CrumbFieldName;
					crumb.Value = data[0][series.CrumbFieldName];
					crumb.DisplayFieldName = series.CrumbDisplayFieldName;
					crumb.DisplayValue = data[0][series.CrumbDisplayFieldName];
					crumb.DefaultPerspective = series.DefaultPerspective;

					mainCategoryLabel.setAttribute('class', 'dataviz main-category-label');
					mainCategoryLabel.setAttribute('coord', JSON.stringify(crumb));
				}
			}
		}

		function addLabelCategories(series, data, mainLabelComponent) {
			var labelCategories = window.document.createElement('ul');
			labelCategories.setAttribute('class', 'label-categories');
			var valueFormat = getValueFormat(series);
			var currencySymbol = getCurrencySymbol(series);
			var baseFormat = getBaseFormat(series);
			var displayCount = getDisplayCount(series);
			var numberOfCategoryPoints = null;

			if (displayCount >= data.length) numberOfCategoryPoints = data.length;else numberOfCategoryPoints = displayCount;

			for (var dataIndex = 0; dataIndex < numberOfCategoryPoints; dataIndex++) {
				var d = data[dataIndex];

				mainLabelComponent.appendChild(labelCategories);

				var labelBox = window.document.createElement('li');
				labelBox.setAttribute('class', 'label-box');

				if (seriesConfig != null) {

					var f = seriesConfig[seriesIndex];
					var tooltip = f.Tooltip;

					if (tooltip != null && tooltip.TooltipConfigs.length > 0) {
						var tooltipConfigs = tooltip.TooltipConfigs;
						for (var tipIndex = 0; tipIndex < tooltipConfigs.length; tipIndex++) {
							var tipItem = tooltipConfigs[tipIndex];

							var tipvalue = chartUtils.getTooltipValue(tipItem, d);

							if (tipItem.TipField == f.SeriesName && tipItem.AggregationType == "") tipValue = d[f.SeriesName];

							d[tipItem.Id] = tipvalue;
						}
					}

					labelBox.addEventListener("touchstart", function (e) {
						labelTooltip.onMouseOver.call(this, e);
					});
					labelBox.addEventListener("mouseover", function (e) {
						labelTooltip.onMouseOver.call(this, e);
					});
					labelBox.addEventListener("mouseout", function () {
						labelTooltip.onMouseOut();
					});
					labelBox.addEventListener("touchmove", function () {
						labelTooltip.onTouchMove();
					});
					labelBox.addEventListener("mousemove", function (e) {
						labelTooltip.onMouseMove.call(this, e);
					});

					var tooltipText = '';
					var tooltip = f.Tooltip;

					if (tooltip != null && tooltip.TooltipConfigs.length > 0 && displayText != null) {
						tooltipText = tooltip.TooltipText;

						for (var tipIndex = 0; tipIndex < tooltip.TooltipConfigs.length; tipIndex++) {
							var tipItem = tooltip.TooltipConfigs[tipIndex];

							var tipValue = d[tipItem.Id];

							if (tipValue == null || tipValue == "--") {

								var field = seriesConfig.find(function (element) {
									return element.labelField == tipItem.TipField;
								});

								if (field != null) tipValue = d[field.labelField];
							}

							if (tipValue != null && tipValue.toString().trim().length > 0) tipValue = chartUtils.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false);

							if (tipValue == null || tipValue.trim().length == 0) tipValue = "--";

							tooltipText = tooltipText.replace("{" + tipItem.TipField + "}", tipValue + " ");
						}
					}
				}

				if (tooltipText != "") labelBox.setAttribute("label", tooltipText);

				labelCategories.appendChild(labelBox);

				var categoryLabel = window.document.createElement('span');
				categoryLabel.setAttribute('class', 'dataviz category-label');
				categoryLabel.setAttribute('seriesidentifier', series.SeriesName);
				categoryLabel.innerHTML = d[series.LabelField];

				var valueLabel = window.document.createElement('span');
				valueLabel.setAttribute('class', LabelConfig.EmphasizeValue ? 'value-label emphasis' : 'value-label');
				valueLabel.innerHTML = chartUtils.format(d[series.ValueField], valueFormat, currencySymbol, null, baseFormat);

				if (series.Description != null && series.Description.toString() != '') {
					var descriptionLabel = window.document.createElement('span');
					descriptionLabel.innerHTML = '&nbsp;' + series.Description;
					valueLabel.appendChild(descriptionLabel);
				}
				if (series.CrumbFieldName != null) {
					var crumb = crumbFormat;
					crumb.Name = series.CrumbMetaName;
					crumb.FieldName = series.CrumbFieldName;
					crumb.Value = d[series.CrumbFieldName];
					crumb.DisplayFieldName = series.CrumbDisplayFieldName;
					crumb.DisplayValue = d[series.CrumbDisplayFieldName];
					crumb.DefaultPerspective = series.DefaultPerspective;

					categoryLabel.setAttribute('coord', JSON.stringify(crumb));
				}
				if (series.FormatConfig != null) applyConditionalFormatting(series, displayText, labelBox, d[series.ValueField], d);
				labelBox.appendChild(categoryLabel);
				labelBox.appendChild(valueLabel);
			}
		}

		function applyConditionalFormatting(labelField, displayText, label, value, d) {
			var conditionalFormats = labelField.FormatConfig;
			for (var cf = 0; cf < conditionalFormats.length; cf++) {
				var conditionalFormat = conditionalFormats[cf];
				displayText = value == '' || value == null ? NaN : value;
				if (conditionalFormat.TableField != '--' && conditionalFormat.TableField != null) displayText = d[conditionalFormat.TableField] == null ? NaN : d[conditionalFormat.TableField];

				if (conditionalFormat.TargetProperty != null && conditionalFormat.TargetProperty != '--') {
					if (d[conditionalFormat.TargetProperty] != null) conditionalFormat.FormatValue = d[conditionalFormat.TargetProperty];
				}
				var expression = chartUtils.buildFormatExpression(conditionalFormat, displayText);
				try {
					if (eval(expression)) {
						applyStyles(conditionalFormat.FormatOption, label);
						break;
					}
				} catch (ex) {
					//Ignore exception & continue to next cell.
					console.log(ex.message);
				}
			}
		}

		function applyStyles(formatOptions, label) {
			if (formatOptions != null && formatOptions.length > 0) {
				for (var fo = 0; fo < formatOptions.length; fo++) {
					var formatOption = formatOptions[fo];
					label.style.backgroundColor = formatOption.Fill;
					label.style.borderColor = formatOption.BorderColor;
					label.style.color = formatOption.ForegroundColor;
				}
			}
		}

		function getValueFormat(series) {
			if (series.ValueFormat == null || series.ValueFormat == '') return labelConfig.ValueFormat;

			return series.ValueFormat;
		}

		function getCurrencySymbol(series) {
			if (series.CurrencySymbol == null) return labelConfig.CurrencySymbol;

			return series.CurrencySymbol;
		}

		function getBaseFormat(series) {
			if (series.BaseFormat == null || series.BaseFormat == 'None') return labelConfig.BaseFormat;

			return series.BaseFormat;
		}

		function getDisplayCount(series) {
			if (series.DisplayCount <= 0 || series.DisplayCount == null) return 200;

			return series.DisplayCount;
		}
	};

	// Initiate rendering for a widget
	var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
		// Get widget specific widgetConfig
		var widgetConfig = labelConfigBuilder.configBuilder(cloneDeep(configObj));
		renderWidget(widgetConfig);
	};

	return {
		renderWidget: renderWidget,
		initiateWidgetRendering: initiateWidgetRendering
	};
};

export default label();